import React from "react";
import { InterviewAssessmentTypes } from "../InterviewAssessmentForm";
import { ChildFormProps } from "../../../types/Form-types";
import ErrorMessage from "../common-components/ErrorMessage";
import RadioCheckboxInput from "../common-components/RadioCheckboxInput";

const languageField: {
  key: keyof InterviewAssessmentTypes;
  label: string;
}[] = [
  { key: "langSpeak", label: "Speak" },
  { key: "langRead", label: "Read" },
  { key: "langWrite", label: "Write" },
];

export const languageOptions = [
  { key: "hindi", label: "Hindi" },
  { key: "english", label: "English" },
  // { key: "bengali", label: "Bengali" },
  // { key: "telugu", label: "Telugu" },
];

interface LanguageDetailsProps extends ChildFormProps {
  handleFieldChange: (name: string, value: string) => void;
}

const LanguageDetails = ({
  formData,
  errors,
  handleFieldChange,
}: LanguageDetailsProps) => {
  // ✅ local wrapper — no changes needed in parent
  const handleLanguageToggle = (
    langKey: keyof InterviewAssessmentTypes,
    optionKey: string,
  ) => {
    const current: string[] = (formData[langKey] as string[]) ?? [];

    const updated = current.includes(optionKey)
      ? current.filter((k) => k !== optionKey) // deselect
      : [...current, optionKey]; // select

    handleFieldChange(langKey as string, updated as any);
  };

  return (
    <>
      <div className="pt-3">
        <p className="form-section-title mb-3 ">Language Proficiency:</p>
        <div className="table-responsive mb-4">
          <table className="form-table">
            <tbody>
              {languageField?.map((lang) => (
                <tr key={lang?.key}>
                  <td className="td-label">{lang?.label}</td>
                  <td>
                    {/* <input
                      name={lang?.key}
                      value={String(formData[lang?.key]) || ""}
                      onChange={(e) =>
                        handleFieldChange(lang.key, e.target.value)
                      }
                    /> */}
                    <div className="mt-2 d-flex flex-wrap gap-4 gap-md-4">
                      {languageOptions?.map((opt) => (
                        <RadioCheckboxInput
                          key={opt.key}
                          id={`${lang.key}-${opt.key}`}
                          name={lang.key}
                          value={opt.key}
                          label={opt.label}
                          type="checkbox" // ✅ CHANGED: added type="checkbox" for multi-select
                          checked={(
                            (formData[lang.key] as string[]) ?? []
                          ).includes(opt.key)} // ✅ CHANGED: array .includes() check instead of === comparison
                          onChange={
                            () => handleLanguageToggle(lang.key, opt.key) // ✅ CHANGED: calls toggle instead of handleFieldChange directly
                          }
                        />
                      ))}
                    </div>
                    {errors?.[lang?.key] && (
                      <ErrorMessage message={errors?.[lang?.key]} />
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default LanguageDetails;
